import React, { Component } from "react"
import { Button,Divider,Table } from 'antd';
import BaseForm from '../../../components/baseForm/baseForm'
export default class WritingState extends Component {
	constructor(props) {
		super(props);
		this.state={
			tableList: []
		}
	}
	handleFilter=(e)=>{
	}
	render() {
		const columns = [
			{
			  title: '序号',
			//   dataIndex: '',
			//   key: '',
			  render: (text, record, index) => (
				<span>
					{index+1}
				</span>
			  ),
            },
            
			{
                title: '纳税人识别号',
                dataIndex: 'idCard',
                key: 'idCard',
			},
			{
			    title: '纳税人名称',
				dataIndex: 'createBy',
				key: 'createBy',
            },
            {
			    title: '税控盘编号',
			    dataIndex: 'userName',
			    key: 'userName',
			},
			{
			    title: '状态信息',
				dataIndex: 'x1',
				key: 'x1',
            },
            {
			    title: '纳税人性质',
				dataIndex: 'x',
				key: 'x',
            },
            { 
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                render: (text, record) => (
                    <div>
                        <Button type="primary" onClick={()=>{this.edit(record)}}>编辑</Button>
                        <Button type="primary" style={{margin: "0 10px"}}>更新</Button>
                        <Button type="danger" onClick={()=>{this.del(record)}}>删除</Button>
                    </div>
                  ),
              }
		  ];
		const formList = [
			{
				type: 'SELECT',
				label: '盘组设备名称',
				field: '1',
				placeholder: '请选择盘组设备名称',
				width: "100%",
				initialValue:'0',
				list:[
					{
						id:'0',name:"未发送"
					},
					
				]
			}, {
				type: 'INPUT',
				label: '纳税人名称',
				field: 'fileName1',
				placeholder: '请输入纳税人名称',
				width: "100%",
			}, {
				type: 'INPUT',
				label: '纳税人识别号',
				field: 'fileName2',
				placeholder: '请输入纳税人识别号',
				width: "100%",
			}, {
				type: 'INPUT',
				label: '税控盘编号',
				field: 'fileName3',
				placeholder: '请输入税控盘编号',
				width: "100%",
			}
		]
		return (
			<div className="menberManager">
				<div className="menberManager-title">
					<h2>反写状态</h2> 
				</div>
				<Divider />
				<div style={{padding:"10px 0"}}>
					<BaseForm formList={formList} filterSubmit={this.handleFilter} />
                </div>
				<div style={{ background: '#C7E2FF'}}>
                    <Button type="link" style={{color: '#333333'}}><img src={require('../../../assets/icon/mac.png')} style={{marginRight: '10px'}}/>状态查询</Button>
				</div>
				<div>
					<Table columns={columns} dataSource={this.state.tableList} />
				</div>

			</div>
		)
	}
}